<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-layout row wrap>
      <v-flex xs12>
        <v-autocomplete
          v-if="false"
          v-model="formData.role"
          :rules="rules.rule"
          :items="roles"
          item-text="name"
          item-value="id"
          :label="$t('inputs.role.name')"
          :error-messages="errorMessages.rule"
          required
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          v-model="formData.full_name"
          :rules="rules.name"
          :label="$t('inputs.full_name.name')"
          :disabled="loading"
          :error-messages="errorMessages.full_name"
          ref="userName"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          v-model="formData.email"
          :rules="rules.email"
          label="E-mail"
          :disabled="loading"
          :error-messages="errorMessages.email"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          vv-model="formData.phone"
          :value="formData.phone"
          :rules="rules.phone"
          :label="$t('inputs.phone.name')"
          v-mask="'(###) ###-##-##'"
          prefix="+7 "
          :error-messages="errorMessages.phone"
          disabled
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          :label="$t('inputs.password.name')"
          v-model="formData.password"
          :hint="$t('inputs.password.hint')"
          min="6"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          @click:append="showPassword = !showPassword"
          required
          :disabled="loading"
          autocomplete="new-password"
          :type="showPassword ? 'text' : 'password'"
        ></v-text-field>
      </v-flex>

      <v-layout row wrap register__form-accept>
        <v-flex xs1>
          <v-checkbox
            color="primary"
            :disabled="loading"
            class="mt-0 pt-0"
            v-model="isPolicyAccepted"
          ></v-checkbox>
        </v-flex>
        <v-flex xs11 pl-3 v-html="$t('registerPage.acceptTextHtml')">
    
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <v-btn
          color="primary"
          @click="validate"
          class="mt-4"
          :disabled="!isValid"
          :loading="loading"
          >{{$t('registerPage.submit')}}</v-btn
        >

        <div v-if="errors">
          <h3 class="error--text">{{ errors }}</h3>
        </div>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import { AUTH_REQUEST } from "../../store/actions/auth";
import { apiCallTrue } from "@/utils/api";
import rules from "@/utils/data/rules";
import roles from "@/utils/data/roles";
import { mask } from "vue-the-mask";

export default {
  name: "RegisterForm",
  directives: { mask },
  data: () => ({
    valid: true,
    isPolicyAccepted: false,
    errors: null,
    errorMessages: {
      full_name: "",
      email: "",
      phone: "",
    },
    showPassword: false,
    loading: false,
    rules,
    roles,
  }),
  props: {
    formData: {
      type: Object,
    },
    confirmData: {
      type: Object,
    },
  },
  computed: {
    isValid() {
      if (
        this.formData.full_name !== "" &&
        this.formData.email !== "" &&
        this.formData.phone !== "" &&
        this.formData.password !== "" &&
        this.formData.password.length >= 6 &&
        this.isPolicyAccepted
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.registerNewUser();
      }
    },
    registerNewUser() {
      try {
        window.dataLayer.push({
          event: "trackEvent",
          eventCategory: "RegisterForm",
          eventAction: "FIO",
          eventLabel: this.formData.full_name,
        });
        window.dataLayer.push({
          event: "trackEvent",
          eventCategory: "RegisterForm",
          eventAction: "Email",
          eventLabel: this.formData.email,
        });
      } catch (e) {
        console.warn(e);
      }

      this.$emit("updateForm", "disableRegisterForm", true);

      const data = Object.assign({}, this.formData, this.confirmData);
      const method = "POST";
      const url = "v1/users/registration";

      this.loading = true;
      apiCallTrue({
        url,
        method,
        data,
      })
        .then((response) => {
          try {
            window.dataLayer.push({
              event: "trackEvent",
              eventCategory: "RegisterForm",
              eventAction: "Success",
            });
          } catch (e) {
            console.warn(e);
          }
          this.autoAuth(response);
        })
        .catch((error) => {
          // this.errors = error.validation;
          // this.errorMessages = error.validation;
          this.errors = error.message;
          this.$emit("updateForm", "disableRegisterForm", false);
          this.loading = false;
        });
    },
    autoAuth(response) {
      if (response.data.result) {
        this.$store
          .dispatch(AUTH_REQUEST, {
            email: this.formData.email,
            password: this.formData.password,
          })
          .then(() => {
            // if (this.formData.role === 10)
            switch (this.formData.role) {
              case 10:
                this.$router.push("/company");
                break;
              case 150:
                this.$router.push("/tenders");
                break;
              default:
                this.$router.push("/");
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
  },
  mounted() {
    // this.$refs.form.reset();
    // this.errors = null;
    this.$refs.userName.focus();
  },
};
</script>

<style></style>
